export interface OrderwiseChannel {
    id: string;
    name: string;
}

export interface OrderwiseIntegration {
    id: string;
    createdAt: string;
    fetchProgress: number;
    masterDataUpdatedAt: string | null;
    masterDataUpdateError: string | null;
    masterDataUpdateActive: boolean;
    name: string;
    username: string;
    password?: string;
    baseUrl: string;
    sessionId: string;
    priceCheckLowerThresholdPercentage: number | null;
    priceCheckUpperThresholdPercentage: number | null;
    integrationParameters: Record<string, any> | null;
    proxy: string;
    attachmentsBaseUrl: string | null;
    orderChannels: OrderwiseChannel[];
    rfqChannels: OrderwiseChannel[];
}

export interface OrderwiseFormData {
    name: string;
    username: string;
    password: string;
    proxy: string;
    baseUrl: string;
    sessionId: string;
    attachmentsBaseUrl: string;
    priceCheckLowerThresholdPercentage: number;
    priceCheckUpperThresholdPercentage: number;
    integrationParameters: Record<string, any>;
    fetchProgress: number;
    orderChannelIds: string[];
    rfqChannelIds: string[];
}

export interface UpdateOrderwiseIntegrationResult {
    updateOrderwiseIntegration: {
        integration: OrderwiseIntegration;
    };
}

export type TabType = 'configuration' | 'order' | 'rfq';

/**
 * Parse a decimal field value that may use comma as decimal separator.
 * Returns null if the value cannot be parsed as a finite number.
 */
export const parseDecimalField = (value: string | number): number | null => {
    const v = Number(String(value).replace(',', '.'));
    return Number.isFinite(v) ? v : null;
};

export const FORM_DEFAULT_VALUES: OrderwiseFormData = {
    name: '',
    username: '',
    password: '',
    proxy: '',
    baseUrl: '',
    sessionId: '',
    attachmentsBaseUrl: '',
    priceCheckLowerThresholdPercentage: 0,
    priceCheckUpperThresholdPercentage: 0,
    integrationParameters: {},
    fetchProgress: 0,
    orderChannelIds: [],
    rfqChannelIds: [],
};
